export const isMacOs = window.navigator.platform.match(/^Mac/)
export const cmdOrCtrl = isMacOs ? 'cmd' : 'Ctrl'

export const keyboardShortcuts = {
   closeSidePane: `esc`,
   leftArrowKey: 'ArrowLeft',
   rightArrowKey: 'ArrowRight',
   openGlobalSearch1: `${cmdOrCtrl}+k`,
   openGlobalSearch2: `${cmdOrCtrl}+K`
}
